export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
  'VA', 'WA', 'WV', 'WI', 'WY'
] as const;

export const DEGREE_OPTIONS = ['MD', 'DO', 'NP', 'PA', 'RN', 'PharmD', 'Other'] as const;

export const HCP_OPTIONS = [
  { value: 'HCP_LICENSED', label: 'Yes, I am a healthcare professional with a license' },
  { value: 'HCP_NOT_LICENSED', label: 'Yes, I am a healthcare professional without a license' },
  { value: 'NOT_HCP', label: 'No, I am not a healthcare professional' }
] as const;

